import React, { useState } from 'react';

import { Trans } from '@lingui/macro';

import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';

import { windowWidth } from '@src/configuration/constants';

import { SwitchProps } from './type';
import styled from 'styled-components/native';
import { Body1 } from '@src/components/Typography';

export const Title = styled(Body1)<{ margin?: Boolean }>`
  font-weight: 600;
  margin-top: ${({ margin }) => (margin ? '2px' : '0px')};
`;

const CustomSwitch = ({
  selectionMode,
  roundCorner,
  option1,
  option2,
  onSelectSwitch,
  selectionColor,
}: SwitchProps) => {
  const [getSelectionMode, setSelectionMode] = useState(selectionMode);
  const [getRoundCorner, setRoundCorner] = useState(roundCorner);

  const updatedSwitchData = (val: number) => {
    setSelectionMode(val);
    onSelectSwitch(val);
  };
  React.useEffect(() => {
    setSelectionMode(selectionMode);
  }, [selectionMode]);
  return (
    <View>
      <View
        style={{
          height: 44,
          width: windowWidth - 32,
          backgroundColor: '#EDEDED',
          borderRadius: getRoundCorner ? 16 : 0,
          borderColor: selectionColor,
          flexDirection: 'row',
          justifyContent: 'center',
        }}
      >
        <TouchableOpacity
          activeOpacity={1}
          onPress={() => updatedSwitchData(1)}
          style={{
            flex: 1,
            backgroundColor: getSelectionMode == 1 ? '#FFD700' : '#EDEDED',
            borderRadius: getRoundCorner ? 16 : 0,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Title>
            <Trans> Specific</Trans>
          </Title>
        </TouchableOpacity>
        <TouchableOpacity
          activeOpacity={1}
          onPress={() => updatedSwitchData(2)}
          style={{
            flex: 1,
            backgroundColor: getSelectionMode == 2 ? '#26B9B0' : '#EDEDED',
            borderRadius: getRoundCorner ? 16 : 0,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Title>
            <Trans>Base</Trans>
          </Title>
        </TouchableOpacity>
      </View>
    </View>
  );
};
export default CustomSwitch;
